import { faX } from '@fortawesome/pro-regular-svg-icons'
import { ReactNode } from 'react'
import { Button, Text, Card, CardColors, Image } from '@/ui'
import { DeviceWidth, useIsDeviceWidth } from '@/utils/deviceWidthHelpers'
import { TypographyStyles, TextColors } from '@/styles'

export const DisplaySampleDataBanner = ({
  imageUrl,
  headerText,
  bodyContent,
  onClose,
}: {
  imageUrl: string
  headerText: string
  bodyContent: ReactNode | string
  onClose?: () => void
}) => {
  const isMobile = useIsDeviceWidth(DeviceWidth.mobile)

  return (
    <Card color={CardColors.LEVEL_0} className="border border-neutral-50 p-10">
      {onClose && (
        <Button
          iconLeft={faX}
          variant="discreet"
          className="absolute right-4 top-4"
          onClick={onClose}
        />
      )}
      <div className="w-full flex flex-col sm:flex-row items-center justify-center gap-6">
        <div className="w-full sm:w-1/4 flex justify-center">
          <Image src={imageUrl} alt="banner" className="h-[150px]" />
        </div>

        <div className="w-full sm:w-3/4">
          <Text
            variant={TypographyStyles.H2}
            className={`mb-4 ${isMobile ? 'text-center' : ''}`}
          >
            {headerText}
          </Text>
          <Text
            variant={TypographyStyles.BODY_SM}
            color={TextColors.MUTED}
            className={isMobile ? 'text-center' : ''}
          >
            {bodyContent}
          </Text>
        </div>
      </div>
    </Card>
  )
}
